import React from "react";

import { Button, Page } from "@samskip/frontend-components";
import { navigate } from "gatsby";
import { useTranslation } from "react-i18next";

import { PROCESSING, NavigationConstants } from "@assets/constants";

interface PostCreatePageProps {
  jobReference?: string;
}

const PostCreatePage: React.FC<PostCreatePageProps> = ({
  jobReference,
}: PostCreatePageProps) => {
  const { t } = useTranslation();

  return (
    <Page
      noTitleUnderline
      size="medium"
      title={
        jobReference === PROCESSING
          ? t("TEXT_QUOTE_X_REGISTERED", { jobReference: "" })
          : t("TEXT_QUOTE_X_REGISTERED", { jobReference: jobReference })
      }
    >
      <p className="mb-6">{t("TEXT_EMAIL_READY_QUOTE")}</p>
      <div className="flex flex-row gap-4">
        <Button
          className="my-1"
          onClick={() => navigate(NavigationConstants.NAVIGATION_LINKS.quotes)}
          variant="secondary"
        >
          {t("LABEL_BACK_TO_QUOTE_LIST")}
        </Button>

        <Button
          className="my-1"
          onClick={() => {
            navigate(`${NavigationConstants.NAVIGATION_LINKS.quotes}/request`);
          }}
        >
          {t("TEXT_REQUEST_NEW_QUOTE")}
        </Button>
      </div>
    </Page>
  );
};

export default PostCreatePage;
